<template>
    <section class="newsletter-simple">
        <alert v-if="alert.type" :type="alert.type" :message="alert.message"></alert>
        <form action="#" @submit.prevent="handleSubmit" class="newsletter-simple">
            <input class="input" type="email" v-model="fields.email" :placeholder="trans.form.email" required />
            <button class="button" type="submit">{{ trans.buttons.sign_up }}</button>
        </form>
    </section>
</template>

<style lang="scss">
    .newsletter-simple .alert {
        text-align: left;
        line-height: 1.2em;
        margin: 10px 0 12px;
    }
</style>

<style lang="scss" scoped>
    .newsletter-simple {
        input[type="text"],
        input[type="email"] {
            width: 100%;
        }

        .button {
            margin-top: 10px;
        }
    }
</style>

<script>
    import Alert from './AlertForm.vue'

    export default {
        props: ['trans'],

        components: { Alert },

        data() {
            return {
                alert: {
                    type: null,
                    message: null,
                },
                fields: {
                    email: '',
                    url: window.location.hostname + window.location.pathname,
                },
            }
        },

        methods: {
            handleSubmit() {
                const { email } = this.fields

                if (email === '') {
                    this.showAlert(this.trans.form.messages.required, 'error')
                    return false
                }

                const url = '/api/newsletter-footer'
                const request = axios.get(url, {
                    params: this.fields,
                })

                request.then(response => {
                    this.resetFormData()
                    this.showAlert(response.data.message, 'success')
                }).catch(error => {
                    console.error(error)
                    this.showAlert(this.trans.form.messages.error, 'error')
                })
            },

            resetFormData() {
                Object.keys(this.fields).map(i => this.fields[i] = '')
            },

            showAlert(message = '', type = null) {
                this.alert = {
                    type,
                    message,
                }
            }
        }
    }
</script>
